export default __webpack_public_path__ + "static/media/atividades.d492fa71.svg";